import { render, staticRenderFns } from "./MrrChartAdmin.vue?vue&type=template&id=6ed379f5"
import script from "./MrrChartAdmin.vue?vue&type=script&lang=js"
export * from "./MrrChartAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports